import { render, staticRenderFns } from "./OrganizationAddressTable.vue?vue&type=template&id=48772dc9&"
import script from "./OrganizationAddressTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationAddressTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports